import styled from 'styled-components';
import { SafeHtml, SafeHtmlProps, T3 } from 'ia-react-core';
import { FC } from 'react';

export const StyledSafeHtml = styled<FC<SafeHtmlProps>>(SafeHtml)`
  flex-flow: wrap;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  > table { 
    margin-top: 16px;
    border-collapse:collapse ;
      > thead{
        th{
          :first-child{
            text-align: left;
            padding-left: 12px;
    }
    :last-child{
      text-align: left;
      padding-left:20px ;
    }
        }
      width: 624px;
      height: 40px;
      margin: 16px 0 11px;
      padding: 11px 341px 10px 12px;
      background-color:${({ theme }) => theme.colors.gray2};

    }
      td{
        p{
          margin-top: 0px;
          :last-child{
      margin-bottom:0px ;
    }
        }
        border-bottom:  solid 0.1px ${({ theme }) => theme.colors.gray2};
        border-top:  solid 0.1px ${({ theme }) => theme.colors.gray2};
        padding-top:12px;
        padding-left: 12px;
        padding-bottom:12px;
        :last-child{
      padding-left:20px ;
      ul{
        padding-left:20px ;
        margin-top: 0px;
        margin-bottom: 0px;
      }
    }
        
      }
    
   
    }
  > p {
    margin-top: 5px;
    margin-bottom: 5px;
    :first-child{
      margin-top:0px ;
    }
    :last-child{
      margin-bottom:0px ;
    }
  
    a {
      text-decoration: none;
      font-weight: 600;
      flex-flow: wrap;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.blue5};
      &:hover {
        text-decoration: inherit;
      }
      &:active {
        color: ${({ theme }) => theme.colors.blue10};
        text-decoration: inherit;
      }
    }

  }
  > ul {
    padding-left: 17px;
    :first-child{
      margin-top:0px ;
    }
    :last-child{
      margin-bottom:0px ;
    }
    li {
      :first-child{
        margin-top:0px ;
      }
      :last-child{
        margin-bottom:0px ;
      }
    }
    a {
      outline: none;
      text-decoration: none;
      white-space: initial;
      word-break: break-word;
      font-weight: 600;
      flex-flow: wrap;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.blue5};
      &:hover {
        text-decoration: inherit;
      }
      &:active {
        color: ${({ theme }) => theme.colors.blue10};
        text-decoration: inherit;
      }
      &:focus {
        box-shadow: 0 0 3px 0 ${({ theme }) => theme.colors.lighter};  
      }
    }

  }
`;
export const StyledLink = styled.div`
  text-align: right;
  margin-top: 13px;
  
  > a & {
    line-height: 1.59;
    :hover {
      text-decoration: underline;
    }
    :active {
      color: ${({ theme }) => theme.colors.blue10};
      text-decoration: underline;
      
    }
  }
`;
export const StyledT3 = styled(T3)`
margin-top: 30px;
margin-bottom: 16px;
`;
export const StyledDiv = styled.div<{ isSubItem: boolean }>`
  margin-top: 20px;
  ${({ isSubItem }) => isSubItem === true && `
  h5{
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0px;
   }
  h4{
    font-size: 14px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif; 
  }
     
  `}
`;
